import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PenLine } from "lucide-react";
import SimpleSignaturePad from "@/components/SimpleSignaturePad";
import { SignaturePickerDialog } from "@/components/SignaturePickerDialog";

export function ServiceReportSignatures({
  customerSignerName,
  setCustomerSignerName,
  signedAt,
  techSigRef,
  technicianSignature,
  setTechnicianSignature,
  custSigRef,
  customerSignature,
  setCustomerSignature,
}) {
  return (
    <Card>
      <CardHeader className="p-4 md:p-6">
        <CardTitle className="flex items-center gap-2 text-lg md:text-xl">
          <PenLine className="w-5 h-5" />
          Unterschriften
        </CardTitle>
        <CardDescription className="text-sm">
          Digitale Unterschriften von Techniker und Kunde
          {signedAt && (
            <span className="ml-2 text-green-600 dark:text-green-400">
              • Unterschrieben am {new Date(signedAt).toLocaleDateString('de-DE')} · kann angepasst werden
            </span>
          )}
        </CardDescription>
      </CardHeader>
      <CardContent className="p-4 md:p-6 pt-0 md:pt-0">
        <div className="space-y-4 mb-4 md:mb-6">
          <div className="space-y-2">
            <Label htmlFor="customerSignerName">Kunde</Label>
            <Input
              id="customerSignerName"
              value={customerSignerName}
              onChange={(e) => setCustomerSignerName(e.target.value)}
              placeholder="Name der Person"
              className="h-11 md:h-9 text-base md:text-sm"
              data-testid="customer-signer-name-input"
            />
          </div>
        </div>
        <div className="grid gap-4 md:gap-6 md:grid-cols-2">
          <div className="space-y-2">
            <div className="flex justify-end">
              <SignaturePickerDialog onSelect={(sig) => setTechnicianSignature(sig)} />
            </div>
            <SimpleSignaturePad
              ref={techSigRef}
              label="Techniker"
              initialValue={technicianSignature}
              onSignatureChange={setTechnicianSignature}
            />
          </div>
          <SimpleSignaturePad
            ref={custSigRef}
            label="Kunde"
            initialValue={customerSignature}
            onSignatureChange={setCustomerSignature}
          />
        </div>
      </CardContent>
    </Card>
  );
}
